import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const hasFirebaseConfig =
  Boolean(firebaseConfig.apiKey) &&
  Boolean(firebaseConfig.authDomain) &&
  Boolean(firebaseConfig.projectId) &&
  Boolean(firebaseConfig.appId);

/** Enable with REACT_APP_USE_FIREBASE_PHONE_AUTH=true and Firebase console config in .env */
export const isFirebasePhoneAuthEnabled = () =>
  process.env.REACT_APP_USE_FIREBASE_PHONE_AUTH === "true" && hasFirebaseConfig;

let app = null;
let auth = null;

if (isFirebasePhoneAuthEnabled()) {
  app = initializeApp(firebaseConfig);
  auth = getAuth(app);

  // Dev only: use with test phone numbers in Firebase Console → Authentication → Phone
  if (
    process.env.NODE_ENV === "development" &&
    process.env.REACT_APP_FIREBASE_APP_VERIFICATION_DISABLED_TESTING === "true"
  ) {
    auth.settings.appVerificationDisabledForTesting = true;
  }
}

export { auth };
